import { ROUTE_PATH, REGION_OPTIONS, STATE_OPTIONS, BRANCH_OPTIONS, BATCH_OPTIONS, CTC_OPTIONS, INDUSTRY_OPTIONS, YEAR_OPTIONS, SEMESTER_OPTIONS, TEMPLATE_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmRadioModel, SmMetaSelectModel, SmDatepickerModel, SmMetaFileModel, SmMetaDynamicFormModel, SmBtnMetaModel, SmMetaTextAreaModel } from "common/models/utility-models/meta-model";
import { MentoringDocumentGridMetaModel } from "../mentoring-document/mentoring-document-grid-meta.model";
import { TravelReimbursementGridMetaModel } from "../travel-reimbursement/travel-reimbursement-grid-meta.model";
import { AssignmentDetailsMetaModel } from "./assignment-details-meta-model";
// import { AssignmentInternshipMetaModel } from "./assignment-internship-meta-model";

export class StudentDetailsMetaModel extends FormMetaModel {
    constructor() {
        super('Student Details', '', ROUTE_PATH.studentDetails, 8);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        // const addStudent=new SmMetaInputModel(
        //     'branchName',
        //     'branchName',
        //     'input',
        //     true,
        //     'form-control',
        //     1,
        //     1,
        //     'Branch Name',
        //     'text',
        //     '',
        //     false,
        //     true,
        //     true,
        //     false,
        //     100,
        //     1
        // );

        const first_name = new SmMetaInputModel(
            'first_name',
            'first_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'First Name',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "First name"
        )

        const last_name = new SmMetaInputModel(
            'last_name',
            'last_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Last Name',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Last Name"
        )

        const father_name = new SmMetaInputModel(
            'father_name',
            'father_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            "Father's Name",
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Father's Name"
        )

        const mother_name = new SmMetaInputModel(
            'mother_name',
            'mother_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            "Mother's Name",
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mother's Name"
        )

        const mobile_number = new SmMetaInputModel(
            'mobile_number',
            'mobile_number',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            'Mobile Number',
            'number',
            '',
            true,
            true,
            true,
            false,
            15,
            10,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Mobile Number"
        )

        const parentMobileNumber = new SmMetaInputModel(
            'parentMobileNumber',
            'parentMobileNumber',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            "Parent's Mobile Number",
            'number',
            '',
            true,
            true,
            true,
            false,
            15,
            10,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Parent's Mobile Number"
        )

        const email = new SmMetaInputModel(
            'email',
            'email',
            'input',
            true,
            'input-fg form-group col-6 col-md-6',
            2,
            3,
            'Email Id',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            5,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Email Id"
        );

        const gender = new SmRadioModel(

            'gender',
            'gender',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 main-gender',
            1,
            2,
            'Gender',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 'Male',
                    value: ['off'],
                    label: 'Male',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 'Female',
                    value: ['off'],
                    label: 'Female',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const address = new SmMetaInputModel(
            'address',
            'address',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Residence Address',
            'text',
            '',
            true,
            true,
            true,
            false,
            200,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Residence Address"
        );
        const age = new SmMetaInputModel(
            'age',
            'age',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Age',
            'number',
            '',
            true,
            true,
            true,
            false,
            2,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Age"
        );
        const region_id = new SmMetaSelectModel(
            'region_id',
            'region_id',
            'ng-select',
            true,
            'col-6 col-md-6',
            1,
            8,
            'Region',
            'ng-select',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            REGION_OPTIONS,
            'zone_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
        );
        const state_id = new SmMetaSelectModel(
            'state_id',
            'state_id',
            'ng-select',
            true,
            'col-12',
            1,
            8,
            'State',
            'ng-select',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            STATE_OPTIONS,
            'stateName',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
        );

        const district_id = new SmMetaSelectModel(
            'district_id',
            'district_id',
            'ng-select',
            true,
            'col-12 col-md-4 mt-3',
            1,
            1,
            'District',
            'select',
            'District',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'District',
            'DistrictId'
        );

        const name_of_college = new SmMetaInputModel(
            'name_of_college',
            'name_of_college',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'College Name',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "College Name"
        );
        const college_address = new SmMetaInputModel(
            'college_address',
            'college_address',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'College Address',
            'text',
            '',
            true,
            true,
            true,
            false,
            200,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "College Address"
        );
        const branch_name = new SmMetaSelectModel(
            'branch_name',
            'branch_name',
            'ng-select',
            false,
            'col-12',
            1,
            8,
            'Branch',
            'select',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            BRANCH_OPTIONS,
            'department_name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
        );
        const batch_number = new SmMetaSelectModel(
            'batch_number',
            'batch_number',
            'ng-select',
            false,
            'col-12',
            1,
            8,
            'Batch',
            'select',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            BATCH_OPTIONS,
            'batch_number',
            'batch_number',
            false,
            false,
            false,
            false,
            false,
            false
        );
        const unique_batch_id = new SmMetaInputModel(
            'unique_batch_id',
            'unique_batch_id',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Unique ID',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Unique ID"
        );
        const mentorId = new SmMetaSelectModel(
            'mentorId',
            'mentorId',
            'select',
            false,
            'col-12 col-md-6 col-lg-6',
            1,
            1,
            'Select Mentor',
            'select',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'mentorName',
            'id',
        );
        const mentor_email = new SmMetaInputModel(
            'mentor_email',
            'mentor_email',
            'input',
            false,
            'input-fg form-group col-6 col-md-6',
            2,
            3,
            'Mentor Email',
            'text',
            '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}',
            true,
            true,
            true,
            false,
            100,
            5
        );
        const mentor_mobile = new SmMetaInputModel(
            'mentor_mobile',
            'mentor_mobile',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            'Mentor Mobile Number',
            'number',
            '',
            true,
            true,
            true,
            false,
            10,
            1
        );
        const remarks = new SmMetaTextAreaModel(
            'remarks',
            'remarks',
            'SimpleTextarea',
            false,
            'col-12 ',
            1,
            2,
            'Mentor Remarks',
            'textarea',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            true
        );
        const summer_vacation_start_date = new SmDatepickerModel(
            'summer_vacation_start_date',
            'summer_vacation_start_date',
            'datepicker',
            false,
            'col-12 col-md-4',
            1,
            1,
            'Vacation Start Date',
            'text',
            '',
            true,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            '',
            [],
            false
        );
        const summer_vacation_end_date = new SmDatepickerModel(
            'summer_vacation_end_date',
            'summer_vacation_end_date',
            'datepicker',
            false,
            'col-12 col-md-4',
            1,
            1,
            'Vacation End Date',
            'text',
            '',
            true,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            '',
            [],
            false
        );
        const winter_vacation_start_date = new SmDatepickerModel(
            'winter_vacation_start_date',
            'winter_vacation_start_date',
            'datepicker',
            false,
            'col-12 col-md-4',
            1,
            1,
            'Vacation Start Date',
            'text',
            '',
            true,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            '',
            [],
            false
        );
        const winter_vacation_end_date = new SmDatepickerModel(
            'winter_vacation_end_date',
            'winter_vacation_end_date',
            'datepicker',
            false,
            'col-12 col-md-4',
            1,
            1,
            'Vacation End Date',
            'text',
            '',
            true,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            '',
            [],
            false
        );
        const first_year_score = new SmMetaInputModel(
            'first_year_score',
            'first_year_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const ktsem1 = new SmRadioModel(

            'ktsem1',
            'ktsem1',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
            1,
            2,
            '',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 1,
                    value: ['off'],
                    label: 'KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 0,
                    value: ['off'],
                    label: 'No KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const second_year_score = new SmMetaInputModel(
            'second_year_score',
            'second_year_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const ktsem2 = new SmRadioModel(

            'ktsem2',
            'ktsem2',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
            1,
            2,
            '',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 1,
                    value: ['off'],
                    label: 'KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 0,
                    value: ['off'],
                    label: 'No KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const third_year_score = new SmMetaInputModel(
            'third_year_score',
            'third_year_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const ktsem3 = new SmRadioModel(

            'ktsem3',
            'ktsem3',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
            1,
            2,
            '',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 1,
                    value: ['off'],
                    label: 'KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 0,
                    value: ['off'],
                    label: 'No KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const fourth_year_score = new SmMetaInputModel(
            'fourth_year_score',
            'fourth_year_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const ktsem4 = new SmRadioModel(

            'ktsem4',
            'ktsem4',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
            1,
            2,
            '',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 1,
                    value: ['off'],
                    label: 'KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 0,
                    value: ['off'],
                    label: 'No KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const first_year2_score = new SmMetaInputModel(
            'first_year2_score',
            'first_year2_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const ktsem5 = new SmRadioModel(

            'ktsem5',
            'ktsem5',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
            1,
            2,
            '',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 1,
                    value: ['off'],
                    label: 'KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 0,
                    value: ['off'],
                    label: 'No KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const second_year2_score = new SmMetaInputModel(
            'second_year2_score',
            'second_year2_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const ktsem6 = new SmRadioModel(

            'ktsem6',
            'ktsem6',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
            1,
            2,
            '',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 1,
                    value: ['off'],
                    label: 'KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 0,
                    value: ['off'],
                    label: 'No KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const third_year2_score = new SmMetaInputModel(
            'third_year2_score',
            'third_year2_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const ktsem7 = new SmRadioModel(

            'ktsem7',
            'ktsem7',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
            1,
            2,
            '',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 1,
                    value: ['off'],
                    label: 'KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 0,
                    value: ['off'],
                    label: 'No KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const fourth_year2_score = new SmMetaInputModel(
            'fourth_year2_score',
            'fourth_year2_score',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'number',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const ktsem8 = new SmRadioModel(

            'ktsem8',
            'ktsem8',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 ',
            1,
            2,
            '',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 1,
                    value: ['off'],
                    label: 'KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 0,
                    value: ['off'],
                    label: 'No KT',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );

        const profile_pic_path = new SmMetaFileModel(
            'profile_pic_path',
            'profile_pic_path',
            'file',
            false,
            'input-fg form-group col-lg-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'profile_pic_path',
            false,
            false,
            2000,
            3000
        );

        // const studentAchievementDetails = new SmMetaDynamicFormModel(
        //     'studentAchievementDetails',
        //     'studentAchievementDetails',
        //     '',
        //     false,
        //     false,
        //     '',
        //     8,
        //     13,
        //     '',
        //     '',
        //     {
        //         title: new SmMetaInputModel(
        //             'title',
        //             'title',
        //             'input',
        //             false,
        //             'input-fg form-group col-5 col-md-5',
        //             1,
        //             1,
        //             'Achievement Name',
        //             'text',
        //             '',
        //             true,
        //             true,
        //             true,
        //             false,
        //             100,
        //             1
        //         ),
        //         uploadAchievement: new SmMetaFileModel(
        //             'uploadAchievement',
        //             'uploadAchievement',
        //             'file',
        //             true,
        //             'input-fg form-group col-lg-6 col-md-6',
        //             4,
        //             7,
        //             '',
        //             '',
        //             '',
        //             true,
        //             true,
        //             true,
        //             false,
        //             0,
        //             0,
        //             false,
        //             ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
        //             3000,
        //             250,
        //             510,
        //             'image',
        //             'filePath',
        //             false,
        //             false,
        //             2000,
        //             3000
        //         )
        //     },
        //     5,
        //     true,
        //     true,
        //     true,
        //     true,
        //     [],
        //     32,
        //     true,
        //     { evalKey: 'userType', evalParam: ['CORP_USER'] }
        // );
        const placement_company_name = new SmMetaInputModel(
            'placement_company_name',
            'placement_company_name',
            'input',
            false,
            'col-12 col-md-3',
            1,
            1,
            'Company Name',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Company Name"
        );
        const placement_company_location = new SmMetaInputModel(
            'placement_company_location',
            'placement_company_location',
            'input',
            false,
            'col-12 col-md-3',
            1,
            1,
            'Company Location',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Company Location"
        );
        const placement_company_designation = new SmMetaInputModel(
            'placement_company_designation',
            'placement_company_designation',
            'input',
            false,
            'col-12 col-md-3',
            1,
            1,
            'Company Designation',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Company Designation"
        );
        const placement_company_package = new SmMetaSelectModel(
            'placement_company_package',
            'placement_company_package',
            'ng-select',
            false,
            'col-12 col-md-4',
            1,
            8,
            'CTC Offered',
            'select',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            CTC_OPTIONS,
            'title',
            'title',
            false,
            false,
            false,
            false,
            false,
            false
        );
        const placement_company_type = new SmMetaSelectModel(
            'placement_company_type',
            'placement_company_type',
            'ng-select',
            false,
            'col-12',
            1,
            8,
            'Industry Type',
            'select',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            INDUSTRY_OPTIONS,
            'placement_company_type',
            'placement_company_type',
            false,
            false,
            false,
            false,
            false,
            false
        );
        const first_year_credit = new SmMetaInputModel(
            'first_year_credit',
            'first_year_credit',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const second_year_credit = new SmMetaInputModel(
            'second_year_credit',
            'second_year_credit',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const third_year_credit = new SmMetaInputModel(
            'third_year_credit',
            'third_year_credit',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const fourth_year_credit = new SmMetaInputModel(
            'fourth_year_credit',
            'fourth_year_credit',
            'input',
            false,
            'col-6 col-md-6',
            1,
            1,
            '',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const year = new SmMetaSelectModel(
            'year',
            'year',
            'ng-select',
            false,
            'col-12',
            1,
            8,
            '',
            '',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            YEAR_OPTIONS,
            'name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
        );

        const application_form = new SmMetaFileModel(
            'application_form',
            'application_form',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const conductCertificate1 = new SmMetaFileModel(
            'conductCertificate1',
            'conductCertificate1',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const enrollment1 = new SmMetaFileModel(
            'enrollment1',
            'enrollment1',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const feeStructure1 = new SmMetaFileModel(
            'feeStructure1',
            'feeStructure1',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const feeReceipt1 = new SmMetaFileModel(
            'feeReceipt1',
            'feeReceipt1',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const resume1 = new SmMetaFileModel(
            'resume1',
            'resume1',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const application2 = new SmMetaFileModel(
            'application2',
            'application2',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const conductCertificate2 = new SmMetaFileModel(
            'conductCertificate2',
            'conductCertificate2',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const enrollment2 = new SmMetaFileModel(
            'enrollment2',
            'enrollment2',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const feeStructure2 = new SmMetaFileModel(
            'feeStructure2',
            'feeStructure2',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const feeReceipt2 = new SmMetaFileModel(
            'feeReceipt2',
            'feeReceipt2',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const resume2 = new SmMetaFileModel(
            'resume2',
            'resume2',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const application3 = new SmMetaFileModel(
            'application3',
            'application3',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const conductCertificate3 = new SmMetaFileModel(
            'conductCertificate3',
            'conductCertificate3',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const enrollment3 = new SmMetaFileModel(
            'enrollment3',
            'enrollment3',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const feeStructure3 = new SmMetaFileModel(
            'feeStructure3',
            'feeStructure3',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const feeReceipt3 = new SmMetaFileModel(
            'feeReceipt3',
            'feeReceipt3',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const resume3 = new SmMetaFileModel(
            'resume3',
            'resume3',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const application4 = new SmMetaFileModel(
            'application4',
            'application4',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const conductCertificate4 = new SmMetaFileModel(
            'conductCertificate4',
            'conductCertificate4',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const enrollment4 = new SmMetaFileModel(
            'enrollment4',
            'enrollment4',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const feeStructure4 = new SmMetaFileModel(
            'feeStructure4',
            'feeStructure4',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const feeReceipt4 = new SmMetaFileModel(
            'feeReceipt4',
            'feeReceipt4',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );
        const resume4 = new SmMetaFileModel(
            'resume4',
            'resume4',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const semester = new SmMetaSelectModel(
            'semester',
            'semester',
            'ng-select',
            false,
            'col-12',
            1,
            8,
            '',
            '',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            SEMESTER_OPTIONS,
            'name',
            'id',
            false,
            false,
            false,
            false,
            false,
            false
        );

        const resultSem1 = new SmMetaFileModel(
            'resultSem1',
            'resultSem1',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const feeReceiptSem1 = new SmMetaFileModel(
            'feeReceiptSem1',
            'feeReceiptSem1',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const resultSem2 = new SmMetaFileModel(
            'resultSem2',
            'resultSem2',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const feeReceiptSem2 = new SmMetaFileModel(
            'feeReceiptSem2',
            'feeReceiptSem2',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const resultSem3 = new SmMetaFileModel(
            'resultSem3',
            'resultSem3',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const feeReceiptSem3 = new SmMetaFileModel(
            'feeReceiptSem3',
            'feeReceiptSem3',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const resultSem4 = new SmMetaFileModel(
            'resultSem4',
            'resultSem4',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const feeReceiptSem4 = new SmMetaFileModel(
            'feeReceiptSem4',
            'feeReceiptSem4',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const resultSem5 = new SmMetaFileModel(
            'resultSem5',
            'resultSem5',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const feeReceiptSem5 = new SmMetaFileModel(
            'feeReceiptSem5',
            'feeReceiptSem5',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const resultSem6 = new SmMetaFileModel(
            'resultSem6',
            'resultSem6',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const feeReceiptSem6 = new SmMetaFileModel(
            'feeReceiptSem6',
            'feeReceiptSem6',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const resultSem7 = new SmMetaFileModel(
            'resultSem7',
            'resultSem7',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const feeReceiptSem7 = new SmMetaFileModel(
            'feeReceiptSem7',
            'feeReceiptSem7',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const resultSem8 = new SmMetaFileModel(
            'resultSem8',
            'resultSem8',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const feeReceiptSem8 = new SmMetaFileModel(
            'feeReceiptSem8',
            'feeReceiptSem8',
            'file',
            false,
            'input-fg form-group col-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'filePath',
            false,
            false,
            2000,
            3000
        );

        const other = new SmMetaTextAreaModel(
            'other',
            'other',
            'SimpleTextarea',
            false,
            'col-12 ',
            1,
            2,
            'Other Information (Working on a start up, working with any company,further study details, etc)',
            'textarea',
            '',
            true,
            true,
            true,
            false,
            250,
            0,
            false,
            false
        );

        const title = new SmMetaInputModel(
            'title',
            'title',
            'input',
            false,
            'col-12 col-md-6 col-lg-6',
            1,
            1,
            '',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            "",
            null,
            false,
            [],
            false,
            "",
            null,
            false,
            false,
            false,
            "Achievement Name"
        );
        const fileOriginalName = new SmMetaFileModel(
            'fileOriginalName',
            'fileOriginalName',
            'file',
            false,
            'col-12 col-lg-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            ['pdf'],
            3000,
            250,
            510,
            'image',
            'fileOriginalName',
            false,
            false,
            2000,
            3000
        );

        const fileName = new SmMetaFileModel(
            'fileName',
            'fileName',
            'file',
            false,
            'col-12 col-lg-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            ['pdf'],
            3000,
            250,
            510,
            'image',
            'fileName',
            false,
            false,
            2000,
            3000
        );

        const annual_year_selection: boolean = true;
        const semi_annual_sem_selection: boolean = false;
        const batchStartYear: string = "";
        const currentYear: string = "2024";
        const studentDocumentDetailYearlyFirst: any = [];
        const studentDocumentDetailYearlySecond: any = [];
        const studentDocumentDetailYearlyThird: any = [];
        const studentDocumentDetailYearlyFourth: any = [];
        const studentDocumentDetailMonthlyFirst: any = [];
        const studentDocumentDetailMonthlySecond: any = [];
        const studentDocumentDetailMonthlyThird: any = [];
        const studentDocumentDetailMonthlyFourth: any = [];
        const studentDocumentDetailMonthlyFifth: any = [];
        const studentDocumentDetailMonthlySixth: any = [];
        const studentDocumentDetailMonthlySeventh: any = [];
        const studentDocumentDetailMonthlyEighth: any = [];
        // const fileName: any = [];
        const pageSize: any = [];
        const uniqueId: string = "";
        const batchs: any = [];
        const batchEndyear: any = [];
        const selectedBatchNumber: any = "";
        const today: Date = new Date();
        const totalDuration: any = [];
        const semesterCount: any = [];
        // const batch_number: any = [];
        const duration_start: any = [];
        const duration_end: any = [];
        const uploadAchievement: any = [];
        const objAssignmentDetailMetaModel = new AssignmentDetailsMetaModel();
        const AssignmentDetailMetaModel = objAssignmentDetailMetaModel.getMetaModel();
        const objTravelReimbursementMetaModel = new TravelReimbursementGridMetaModel();
        const TravelReimbursementMetaModel = objTravelReimbursementMetaModel.getMetaModel();
        const objMentoringDocumentMetaModel = new MentoringDocumentGridMetaModel();
        const MentoringDocumentMetaModel = objMentoringDocumentMetaModel.getMetaModel();
        const isInternshipCertyVerified: any = "";
        // const AssignementInternshipMetaModel = new AssignmentInternshipMetaModel();
        // const studentDetailsGridData = [];

        // const buttons = {
        //     submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
        //     isFormControl: false
        // };
        const batch_duration_start: string = '';

        const buttons = {
            submit: new SmBtnMetaModel('Save', '', true, false, true, true),
            changeMentor: new SmBtnMetaModel('Change Mentor', 'primary', true, false, true, false),
            isFormControl: false
        };
        const isEditable = [
            first_name,
            last_name,
            father_name,
            mother_name,
            mobile_number,
            parentMobileNumber,
            email,
            gender,
            address,
            age,
            region_id,
            state_id,
            name_of_college,
            college_address,
            branch_name,
            mentorId,
            first_year_score,
            second_year_score,
            third_year_score,
            fourth_year_score,
            first_year2_score,
            second_year2_score,
            third_year2_score,
            fourth_year2_score,
            ktsem1,
            ktsem2,
            ktsem3,
            ktsem4,
            ktsem5,
            ktsem6,
            ktsem7,
            ktsem8,
            // placement_company_name,
            // placement_company_location,
            // placement_company_designation,
            // placement_company_package,
            // industryType,
            first_year_credit,
            second_year_credit,
            third_year_credit,
            fourth_year_credit,
            district_id,
            other,
        ]



        return {
            formInfo,
            buttons,
            first_name,
            last_name,
            father_name,
            mother_name,
            mobile_number,
            parentMobileNumber,
            email,
            gender,
            address,
            annual_year_selection,
            semi_annual_sem_selection,
            batchStartYear,
            currentYear,
            studentDocumentDetailYearlyFirst,
            studentDocumentDetailYearlySecond,
            studentDocumentDetailYearlyThird,
            studentDocumentDetailYearlyFourth,
            studentDocumentDetailMonthlyFirst,
            studentDocumentDetailMonthlySecond,
            studentDocumentDetailMonthlyThird,
            studentDocumentDetailMonthlyFourth,
            studentDocumentDetailMonthlyFifth,
            studentDocumentDetailMonthlySixth,
            studentDocumentDetailMonthlySeventh,
            studentDocumentDetailMonthlyEighth,
            fileName,
            pageSize,
            uniqueId,
           // studentAchievementDetails,
            region_id,
            state_id,
            name_of_college,
            college_address,
            branch_name,
            // batch,
            unique_batch_id,
            mentorId,
            mentor_email,
            mentor_mobile,
            summer_vacation_start_date,
            summer_vacation_end_date,
            winter_vacation_start_date,
            winter_vacation_end_date,
            batchs,
            batchEndyear,
            selectedBatchNumber,
            today,
            totalDuration,
            semesterCount,
            batch_number,
            duration_start,
            duration_end,
            first_year_score,
            second_year_score,
            third_year_score,
            fourth_year_score,
            first_year2_score,
            second_year2_score,
            third_year2_score,
            fourth_year2_score,
            ktsem1,
            ktsem2,
            ktsem3,
            ktsem4,
            ktsem5,
            ktsem6,
            ktsem7,
            ktsem8,
            placement_company_name,
            placement_company_location,
            placement_company_designation,
            placement_company_package,
            placement_company_type,
            first_year_credit,
            second_year_credit,
            third_year_credit,
            fourth_year_credit,
            year,
            age,
            application_form,
            conductCertificate1,
            enrollment1,
            feeStructure1,
            feeReceipt1,
            resume1,
            application2,
            conductCertificate2,
            enrollment2,
            feeStructure2,
            feeReceipt2,
            resume2,
            application3,
            conductCertificate3,
            enrollment3,
            feeStructure3,
            feeReceipt3,
            resume3,
            application4,
            conductCertificate4,
            enrollment4,
            feeStructure4,
            feeReceipt4,
            resume4,
            semester,
            resultSem1,
            feeReceiptSem1,
            resultSem2,
            feeReceiptSem2,
            resultSem3,
            feeReceiptSem3,
            resultSem4,
            feeReceiptSem4,
            resultSem5,
            feeReceiptSem5,
            resultSem6,
            feeReceiptSem6,
            resultSem7,
            feeReceiptSem7,
            resultSem8,
            feeReceiptSem8,
            uploadAchievement,
            AssignmentDetailMetaModel,
            profile_pic_path,
            batch_duration_start,
            // AssignementInternshipMetaModel,
            TravelReimbursementMetaModel,
            isEditable,
            remarks,
            district_id,
            MentoringDocumentMetaModel,
            other,
            isInternshipCertyVerified,
            title,
            fileOriginalName
            // addStudent
        }
    }
}